import styled from "styled-components";
import { CLOUDN_COLORS } from "../../../constants/colors";
import { PeakPercentProps } from "../../../constants/types";

const PeakPercent = (props: PeakPercentProps) => {
  return (
    <Container>
      <Type>
        {props.type}
        <br />
        대비
      </Type>
      <Percent>
        {props.percent}
        <span className="unit">%</span>
      </Percent>
    </Container>
  );
};

export default PeakPercent;

const Container = styled.div`
  width: 48%;
  height: 23%;
  box-sizing: border-box;

  background-color: ${CLOUDN_COLORS.skyBlue};
  border-radius: 10px;
  padding: 3%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Type = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${CLOUDN_COLORS.deepNavy};
  font-weight: 500;
`;

const Percent = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2vw;
  font-weight: 500;
  color: ${CLOUDN_COLORS.deepNavy};
  .unit {
    font-size: 1vw;
    font-weight: 600;
    padding: 10% 0 0 5%;
  }
`;
